export default {
  type: 'client_alias',
  config: {
    relationships: {
      alias_config: {
        type: 'alias_config'
      }
    }
  }
};
//# sourceMappingURL=client_alias.js.map